'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKEND_HOST_MAP = exports.BACKEND_HOST_MAP = {
  development: 'http://localhost:3000',
  E1: 'https://cardshop-dev.aexp.com',
  E2: 'https://cardshop-qa.americanexpress.com',
  E3: 'https://cardshop2.americanexpress.com'
};

var CORPORATE_SHOPS = exports.CORPORATE_SHOPS = [{
  businessMarket: 'business',
  shopName: 'corporate-pre-qual'
}];

var BUSINESS_SHOPS = exports.BUSINESS_SHOPS = [{
  businessMarket: 'business',
  shopName: 'prequalify-for-business-credit-card'
}];

var joinParams = function joinParams(list, paramKey) {
  return list.map(function (li) {
    return li[paramKey];
  }).join('|');
};
var buildV4Url = function buildV4Url(shop) {
  return ['/:countryCode', '/credit-cards', '/:businessMarket(' + joinParams(shop, 'businessMarket') + ')', '/:shop(' + joinParams(shop, 'shopName') + ')'].join('');
};

// this is for dev-mode (localhost) consumption within this repo:
var ROUTES_V4 = exports.ROUTES_V4 = {
  PreQualSmallBusiness: buildV4Url(BUSINESS_SHOPS),
  PreQualCorporate: buildV4Url(CORPORATE_SHOPS)
};

var buildV3Url = function buildV3Url(shopList) {
  return shopList.map(function (shop) {
    return '/:countryCode/credit-cards/' + shop.businessMarket + '/' + shop.shopName;
  });
};

// this is for the hosting app consumtion (gcp/cgs-SHOP repo):
var ROUTES = exports.ROUTES = {
  PreQualSmallBusiness: buildV3Url(BUSINESS_SHOPS),
  PreQualCorporate: buildV3Url(CORPORATE_SHOPS)
};